/* eslint-disable camelcase */
import { Component } from 'react';

class PriceItPlusPoints extends Component {
  render() {
    const {
      data: {
        submitted, points_earned, approved, points_awarded
      }
    } = this.props;

    return (
      <div className="further-information">
        <div className="further-information-body">
          <div className="separator sell-it" />
          <div className="further-information-section">
            <div className="no-padding points">
              <div className="point-reward-summary">
                <div className="points-earned">
                  <h2>Submitted</h2>
                  <strong>
                    {(submitted && submitted.toLocaleString('en', { useGrouping: true })) || 0}
                  </strong>
                </div>
                <div className="points-awarded">
                  <h2>Points earned</h2>
                  <strong>
                    {(points_earned && points_earned.toLocaleString('en', { useGrouping: true })) || 0}
                  </strong>
                </div>
                <div className="points-earned">
                  <h2>Approved</h2>
                  <strong>
                    {(approved && approved.toLocaleString('en', { useGrouping: true })) || 0}
                  </strong>
                </div>
                <div className="points-awarded">
                  <h2>Points awarded</h2>
                  <strong>
                    {(points_awarded && points_awarded.toLocaleString('en', { useGrouping: true })) || 0}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PriceItPlusPoints;
